import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { App } from './App';
import { MiApp } from './mi/MiApp';
import { DealDeskApp } from './dealdesk/DealDeskApp';
import { RootGate } from './RootGate';
import { Selector } from './Selector';
import './styles/globals.css';

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <BrowserRouter>
      <Routes>
        <Route path="/"             element={<RootGate />} />
        <Route path="/select"       element={<Selector />} />
        {/* The old workbench is retired from its route (front of funnel
            moved to /mi, deal depth to /deal-desk). The stripped shell
            stays parked at an unlisted legacy path only because it still
            holds pieces ruled keep (Ask Claude, comps, package) until
            Deal Desk inherits them. */}
        <Route path="/workbench/*"  element={<Navigate to="/select" replace />} />
        <Route path="/workbench-legacy/*" element={<App />} />
        <Route path="/deal-desk/*"  element={<DealDeskApp />} />
        <Route path="/mi/*"         element={<MiApp />} />
        <Route path="*"             element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  </React.StrictMode>,
);
